<div
  class="banner {{ bannerType }}"
  [ngClass]="{
    'banner--no-img': !withImage,
    'banner--text-left': bannerComponent.alignment === alignment.LEFT,
    'banner--text-right': bannerComponent.alignment === alignment.RIGHT,
    'banner--text-center': bannerComponent.alignment === alignment.CENTER,
  }"
>
  @if (withImage) {
    <div class="banner__img" [class.banner__img--no-gradient]="removeGradient">
      <boels-media
        [container]="bannerComponent.media"
        [alt]="bannerComponent.imageAltText"
        [loading]="ImageLoadingStrategy.LAZY"
        [sizes]="
          '(min-width: 576px) 510px, ' +
          '(min-width: 768px) 690px, ' +
          '(min-width: 992px) 930px, ' +
          '330px'
        "
      ></boels-media>
    </div>
  }

  <div
    class="column column--content"
    [class.column--content-no-gradient]="removeGradient"
  >
    <h3 class="banner__title">{{ bannerComponent.title }}</h3>
    <p class="banner__text" [ngClass]="{ 'mb-0': !bannerComponent.link }">
      {{ bannerComponent.subtitle }}
    </p>
    @if (bannerComponent.link) {
      <a
        boelsAnchorButton
        boelsGenericLink
        tabindex="0"
        class="banner__link"
        [variant]="'primary-brand'"
        [componentData]="bannerComponent"
      >
        {{ bannerComponent.link.linkName ?? bannerComponent.title }}
      </a>
    }
  </div>
</div>
